import doFetch from './doFetch';

export default function () {
  return async (hmsId = null) => {
    await doFetch(`/dealerships/refresh`, { method: 'POST', body: JSON.stringify({ hmsId }) });
  };
}
